
import type { PropType } from 'vue'
import { defineComponent, watch, reactive, computed } from 'vue'

import Invoices from './Invoices.vue'

// > services/types <
import { WaybillDetails } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

// > services/waybills
import waybillsAPI from '@/modern/modules/m-dispatcher-module/services/waybill.service'

// > helpers/formatDate <
import formatDate from '@/modern/helpers/formatDate'

// > helpers/formatPriceToTenge <
import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    components: {
        Invoices
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        waybillId: {
            type: [Number, null] as PropType<number | null>,
            default: null
        }
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const state = reactive({
            isLoading: false,
            isFailed: false,
            details: null as WaybillDetails | null,
        })

        const onClose = () => {
            if (props.disabled) return
            emit('close')
        }

        const onUpdateModelValue = (newValue: boolean) => {
            if (props.disabled) return
            emit('update:modelValue', newValue)
        }

        const loadWaybillDetails = async () => {
            if (!props.waybillId) return

            try {
                state.isLoading = true

                const response = await waybillsAPI.getWaybillDetails(props.waybillId as number)
                state.details = response.data.data

                state.isFailed = false
            } catch (error) {
                console.error(error)
                state.isFailed = true
            } finally {
                state.isLoading = false
            }
        }

        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue) {
                    loadWaybillDetails()
                }
            }
        )

        const total = computed(() => {
            if (state.details) {
                const additionalServicesTotalAmount = Number(state.details.additionalServicesTotalAmount)
                const ndsTotalAmount = Number(state.details.ndsTotalAmount)
                return additionalServicesTotalAmount + ndsTotalAmount
            }

            return 0
        })

        return {
            formatDate,
            formatPriceToTenge,
            state,
            onClose,
            onUpdateModelValue,
            loadWaybillDetails,
            total,
        }
    }
})
